var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.tag, _vm._b({
    tag: "component",
    staticClass: "chip",
    class: [_vm.colorString ? 'chip-' + _vm.colorString : '', _vm.sizeString ? 'chip-' + _vm.sizeString : '', {
      'is-active': _vm.hasActiveState,
      'has-icon': !!_vm.icon,
      'is-clickable': _vm.clickable && !_vm.disabled,
      'opacity-75': _vm.disabled,
      'text-white': !!_vm.colorHex
    }],
    style: _vm.style,
    on: {
      "click": _vm.handleClick
    }
  }, 'component', _vm.linkProps, false), [_vm.icon ? _c('icon', {
    attrs: {
      "icon": _vm.icon,
      "size": _vm.iconSize,
      "prominent": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("left"), _vm._v(" "), _c('span', {
    staticClass: "chip__content truncate"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.close ? _c('icon', {
    staticClass: "ml-8 cursor-pointer",
    attrs: {
      "icon": _vm.$icons.close,
      "x-small": _vm.small || _vm.xSmall,
      "small": !_vm.small && !_vm.xSmall
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('click:close');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.help ? _c('tooltip', {
    attrs: {
      "bottom": "",
      "text": _vm.help,
      "with-touch": ""
    }
  }, [_c('icon', {
    staticClass: "ml-8",
    attrs: {
      "icon": _vm.$icons.help,
      "xx-small": _vm.xSmall,
      "x-small": _vm.small,
      "small": !_vm.small && !_vm.xSmall
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("right")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }